export const apiConstants = {
  storage: '/storage',
};
